import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Hero from '../components/Hero';
import { DefaultLogoReel } from '../components/LogoReel';
import SectionHero from '../components/SectionHero';
import IndustryList from '../components/IndustryList';
import PartnerCard from '../components/PartnerCard';
import InfiniteRefinementIndexGrid from '../components/InfiniteRefinementIndexGrid';
import TestimonialCard from '../components/TestimonialCard';
import Section from '../components/Section';

const PartnersIndexTemplate = ({ pageContext: { page } }) => {
  const { caseStudies } = useStaticQuery(graphql`
    {
      caseStudies: allGraphCmsCaseStudy(
        filter: {
          remoteId: {
            in: ["ck5nppto8pxiw0b75q1wrmac6", "ck5nspynoqjyo0b75cdrl3awb"]
          }
        }
      ) {
        nodes {
          id
          slug
          friendlySlug
          title
          subTitle
          coverImage {
            ...assetData
          }
          excerpt
          hasContent
          content
          company {
            name
            url
            logo {
              ...assetData
            }
          }
          customer {
            ...authorData
          }
          linkPath
        }
      }
    }
  `);

  return (
    <React.Fragment>
      <Section>
        <Hero {...page} alignment="left" />
      </Section>
      <DefaultLogoReel className="mb-16 md:mb-24" />
      <Section colour="light">
        <SectionHero
          noHr
          title="GraphCMS Partner Network"
          description="Find a partner from our network to assist you in your next project"
        />

        <InfiniteRefinementIndexGrid
          indexName={process.env.GATSBY_ALGOLIA_PARTNERS_INDEX_NAME}
          Component={PartnerCard}
          refinements={[
            {
              label: 'Regions serviced',
              attribute: 'friendlyRegionsServiced',
            },

            {
              label: 'Services offered',
              attribute: 'friendlyServicesOffered',
            },
          ]}
        />
      </Section>
      <Section>
        <SectionHero
          title="Join our partnership program"
          description="GraphCMS enables partners to fulfill client specifications faster, and at ease"
          ctas={[{ href: '/contact', label: 'Become a GraphCMS Partner' }]}
        />

        <IndustryList entries={caseStudies.nodes} Component={TestimonialCard} />
      </Section>
    </React.Fragment>
  );
};

export default PartnersIndexTemplate;
